import { Controller } from "react-hook-form";
import libForm from "../../../../util/libForm";

function SelectInputSimple({ id, control }) {
	return (
		<div className="content-select">
			<div className="input-select-box d-flex flex-column col-6 col-sm-6 col-lg-3  min-w-52">
				<label htmlFor="tipo-venda">Tipo de venda</label>
				<Controller
					name={id}
					control={control}
					defaultValue=""
					render={({ field }) => (
						<select {...field} onKeyDown={(e) => libForm.EnterTab(e)}>
							<option value="" disabled hidden>
								TODAS AS VENDAS
							</option>
							<option value="">TODAS AS VENDAS</option>
							<option value="LOCAL">VENDAS LOCAL</option>
							<option value="ONLINE">VENDAS ON-LINE</option>
						</select>
					)}
				/>
			</div>
		</div>
	);
}

export default SelectInputSimple;
